import { REFI_PERSONAL_CONST } from '../constants/app.constants.js';
import { ApiService } from '../../core/services/api/api.service.js';
import { DebugService } from './debug.service.js';
import { ApplicationService } from '../../services/application.service.js';

export class _FeatureToggleService {
  constructor() {
    this.debug = new DebugService('FeatureToggleService');
    this._featureToggles = [];
    this.toggleUpdatePromise = null;
  }

  setFeatureToggles(featureToggles) {
    this._featureToggles = featureToggles;
  }

  async getFeatureToggleStatus(featureKey, returnCached = true) {
    this.debug.log('searching for feature', featureKey);
    const url = REFI_PERSONAL_CONST.GET_FEATURE_TOGGLE_URL(featureKey);
    let featureStatus = [
      this._featureToggles.find(
        (feature) => feature.featureKey === featureKey
      ) || false,
    ];
    try {
      if (!featureStatus[0] || !returnCached) {
        featureStatus = await ApiService.get(url);
      }
      // if the retrieved feature exists, replace. otherwise, add.
      const existingIndex = this._featureToggles.findIndex(
        (existingFeature) =>
          existingFeature.featureKey === featureStatus.featureKey
      );
      if (existingIndex !== -1) {
        this._featureToggles[existingIndex] = featureStatus;
      } else {
        this._featureToggles.push(featureStatus);
      }
      this.updateStratumExperiments(featureStatus, window.location.href);
      return featureStatus[0].isEnabled;
    } catch (error) {
      this.debug.log('error getting feature toggle status', error);
    }
    return featureStatus[0];
  }

  async getMultipleFeatureToggleStatus(featureKeys, returnCached = true) {
    let url = REFI_PERSONAL_CONST.GET_FEATURE_TOGGLE_URL('~');
    url = `${url}?featureKeys=${featureKeys}`;
    let featureList = [];

    try {
      // check if each key in comma separated featureKeys exists in _featureToggles
      const keySet = featureKeys.split(',');
      const cachedResponseKeySet = this._featureToggles.map(
        (feature) => feature.featureKey
      );
      if (
        !returnCached ||
        !keySet.every((featureKey) => cachedResponseKeySet.includes(featureKey))
      ) {
        featureList = await ApiService.get(url);
      }
      // add any new features to the list.
      this._featureToggles = featureList.concat(
        this._featureToggles.filter(
          (existingFeature) =>
            !featureList.some(
              (newFeature) =>
                newFeature.featureKey === existingFeature.featureKey
            )
        )
      );

      this.updateStratumExperiments(this._featureToggles, window.location.href);
      return this._featureToggles;
    } catch (error) {
      this.debug.log('error getting feature toggle status', error);
    }
    return null;
  }

  updateStratumExperiments(arrayOfFeatureObjects) {
    const newlyAddedFeatures = [];
    const removedFeatures = [];
    arrayOfFeatureObjects.forEach((featureObj) => {
      newlyAddedFeatures.push(
        featureObj.featureKey + (featureObj.isEnabled ? '-test' : '-bau')
      );
      removedFeatures.push(
        featureObj.featureKey + (featureObj.isEnabled ? '-bau' : '-test')
      );
    });
    ApplicationService.updateExperiments(newlyAddedFeatures, removedFeatures);
  }

  updateIsIconicAndToggledOn(returnCachedPromise = true) {
    if (this.toggleUpdatePromise && returnCachedPromise) {
      this.debug.log('returning cached promise', this.toggleUpdatePromise);
      return this.toggleUpdatePromise;
    }
    this.toggleUpdatePromise = this.updateIconicToggle();
    return this.toggleUpdatePromise;
  }

  async updateIconicToggle() {
    if (ApplicationService.experiments?.includes('iconic-invisible-pq-only')) {
      ApplicationService.isIconicAndToggledOn = true;
    } else if (ApplicationService.experiments?.includes('iconic-test')) {
      ApplicationService.isIconicAndToggledOn =
        await this.getFeatureToggleStatus(
          REFI_PERSONAL_CONST.FEATURE_TOGGLES.ICONIC_PQ_FEATURE_TOGGLE
        );
    } else {
      ApplicationService.isIconicAndToggledOn = false;
    }
  }

  async updateRemovePrimarySSNToggle() {
    if (
      ApplicationService.experiments?.includes(REFI_PERSONAL_CONST.ICONIC_V2)
    ) {
      ApplicationService.hidePrimarySSN = await this.getFeatureToggleStatus(
        REFI_PERSONAL_CONST.FEATURE_TOGGLES.ICONIC_REMOVE_PRIMARY_SSN
      );
    }
  }
}

export const FeatureToggleService = new _FeatureToggleService();
